import { SellerManageComponent } from './seller-manage/seller-manage.component';
export var sellerRoutes = [
    {
        path: 'seller',
        data: {
            'expectedRoles': ['Admin', 'IT']
        },
        children: [
            {
                path: 'manage',
                component: SellerManageComponent
            }
        ]
    }
];
var SellerRoutingModule = (function () {
    function SellerRoutingModule() {
    }
    return SellerRoutingModule;
}());
export { SellerRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/seller/seller-routing.module.ts.pre-build-optimizer.js